import { i18n } from '@/locales';
export const pageSizeEnum = {
    20: '20',
    /** Default */
    50: '50',
    100: '100',
};
export const pageSizeOptionsType = [
    pageSizeEnum['20'],
    pageSizeEnum['50'],
    pageSizeEnum['100'],
];
export default pageSizeOptionsType.map((size) => ({
    text: `${size} ${i18n.t('unit.number')}`,
    value: size,
    field: 'pageSize',
}));
